'use client';

import type { ComponentProps } from 'react';

import { withClientAuth } from '@ps/ui/contexts/auth/with-client-auth';

import { CalendarBookingProvider } from '../context/provider';
import { BookingView } from './booking-view';

/**
 * BookingView wrapped with CalendarBookingProvider + withClientAuth.
 * Used by the lazy wrapper so everything loads in one deferred chunk.
 * withClientAuth adds AuthProvider + UserProfileProvider when absent
 * (public view), and is a no-op when they already exist (editor).
 */
function BookingViewWithProviderInner(
  props: ComponentProps<typeof BookingView>,
) {
  return (
    <CalendarBookingProvider storeId={props.storeId}>
      <BookingView {...props} />
    </CalendarBookingProvider>
  );
}

export const BookingViewWithProvider = withClientAuth(
  BookingViewWithProviderInner,
);
